<template>
    <ValidationObserver v-slot="{ invalid, errors, dirty }" ref="observer">
        <form class="flex items-start flex-col gap-4">
            <app-checkbox
                :label="$t('project.follow.meetings.showCoverPage')"
                v-model="meeting.showCoverPageWithPhoto"
                @input="onCheck('showCoverPageWithPhoto')"
            />
            <app-checkbox
                :label="$t('project.follow.meetings.showParticipantsIndex')"
                v-model="meeting.showParticipantsIndex"
                @input="onCheck('showParticipantsIndex')"
            />

            <app-checkbox
                :label="$t('project.editions.meetingReports.description')"
                v-model="meeting.showDescription"
                @input="onCheck('showDescription')"
            />

            <app-checkbox
                :label="$t('project.follow.meetings.showGeneralProgress')"
                v-model="meeting.showGeneralProgress"
                @input="onCheck('showGeneralProgress')"
            />

            <app-checkbox
                :label="$t('project.follow.meetings.showTasksTable')"
                v-model="meeting.showTasksTable"
                @input="onCheck('showTasksTable')"
                v-if="isMOE && project_EXE"
            />
            <app-checkbox
                :label="$t('project.follow.meetings.showPlanning')"
                v-model="meeting.showPlanning"
                @input="onCheck('showPlanning')"
                v-if="isMOE && (project_EXE || project_CON) && hasTasks"
            />
            <app-checkbox
                :label="$t('project.follow.meetings.showGeneralObservations')"
                v-model="meeting.showGeneralObservations"
                @input="onCheck('showGeneralObservations')"
                v-if="isMOE && project_EXE"
            />
            <app-checkbox
                :label="$t('project.follow.meetings.showPenaltiesTable')"
                v-model="meeting.showPenaltiesTable"
                @input="onCheck('showPenaltiesTable')"
                v-if="project_EXE && project_feature_amendments"
            />
            <app-checkbox
                :label="$t('project.follow.meetings.showAmendmentsTable')"
                v-model="meeting.showAmendmentsTable"
                @input="onCheck('showAmendmentsTable')"
                v-if="project_EXE && project_feature_amendments"
            />
        </form>
    </ValidationObserver>
</template>

<script>
import { getMeeting, updateMeeting } from './meetings.service';
import AppCheckbox from '@/components/app-checkbox/AppCheckbox';
import { combineLatest } from 'rxjs';
import { getProject } from '@/features/projects/projects.service';
import { getTasks } from '@/features/tasks/tasks.service';
export default {
    components: {
        AppCheckbox,
    },
    created() {
        this.subscriptions = [
            combineLatest([
                getMeeting(this.$route.params.projectId, this.$route.params.meetingId),
                getProject(this.$route.params.projectId),
                getTasks(this.$route.params.projectId),
            ]).subscribe(([meeting, project, tasks]) => {
                this.meeting = meeting;
                this.isMOE = meeting.type === 'MOE';
                this.project_EXE = project.projectFeatures.includes('project_EXE');
                this.project_CON = project.projectFeatures.includes('project_CON');
                this.hasTasks = tasks.length > 0;
                this.project_feature_amendments = project.projectFeatures.includes('project_feature_amendments');
            }),
        ];
    },
    methods: {
        onCheck(key) {
            this.saveMeeting({ [key]: this.meeting[key] });
        },
        async saveMeeting(meetingEntity) {
            await updateMeeting(this.$route.params.projectId, { id: this.meeting.id, ...meetingEntity });
        },
    },
    data() {
        return {
            meeting: {},
            subscriptions: [],
            hasTasks: false,
            project_feature_amendments: false,
            isMOE: false,
            project_EXE: false,
            project_CON: false,
        };
    },
};
</script>
